module.exports = __webpack_public_path__ + "docs/img/rocket.ef0365e8.png";